import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { TechniqueNames } from './dtos/technique.dto'
import { InstructionCheckAvailability } from '../../jobsites-management/jobsite-summary/models/instruction-check-availability.model'

@Injectable()
export class RestInstructionService {
  private http = inject(HttpClient)

  private baseUrl = 'rest'

  public checkAvailability(
    technique: TechniqueNames,
    instruction: InstructionCheckAvailability,
  ): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.baseUrl}/${technique}/data/preparation/check-pile-availability`,
      instruction,
    )
  }
}
